import { render, staticRenderFns } from "./SettingsEmail.vue?vue&type=template&id=6bf745d7"
import script from "./SettingsEmail.vue?vue&type=script&lang=js"
export * from "./SettingsEmail.vue?vue&type=script&lang=js"
import style0 from "./SettingsEmail.vue?vue&type=style&index=0&id=6bf745d7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports